import React from 'react';
import { Link } from 'react-router-dom';
import Avatar from '../../shared/components/UIElements/Avatar';
import Card from '../../shared/components/UIElements/Card';
import './DatasetSnippet.css';

const DatasetSnippet = props => {
  return (
    <li className="dataset-item">
      <Card className="dataset-item__content">
        <Link to={`/datasets/${props.id}`}>
       
          <div className="dataset-item__image">
            <Avatar image={props.image} alt={props.title} />
          </div>
          <div className="dataset-item__info">
            <h3>{props.title}</h3>
            <h5>{props.description}</h5>
            <p> Classes: {props.numOfClasses} &nbsp;&nbsp; Entities: {props.numOfEntities} &nbsp;&nbsp; Recommendations: {props.numOfRecommendations} </p>
          </div>
          <div className="dataset-item__active"> 
                <span 
                    title={props.active ? "Endpoint Active" : "Endopint Inactive"} 
                    class={props.active ? "dataset-active" : "dataset-inactive"}>
                </span>
           </div>
        </Link>
      </Card>
     
    </li>
  );
};

export default DatasetSnippet;